import {
    call,
    put,
    select,
} from 'redux-saga/effects'

import Internal from 'common/modules/internal'
import Router from 'common/modules/router'
import Zoid from 'common/modules/zoid'

import {
    APP_ERROR_TAG,
} from 'common/tags'
import { creators } from '../actions'

const maxRetries = 3

export default function* sendAppError({
    payload: {
        tag,
    } = {},
} = {}) {
    try {
        const {
            arbiter: {
                appErrors,
            },
        } = yield select()

        const { sendHostMessage } = yield select(Zoid.selectors.getXprops)

        if (appErrors <= maxRetries) {
            yield put(Internal.creators.sendMessage({
                payload: {
                    target: tag,
                    ...Router.creators.refresh(),
                },
            }))
        } else {
            yield call(sendHostMessage, 'FRAME/ERROR')

            const payload = yield select(Zoid.selectors.getXpropsChildPayload)

            yield put(creators.createChild({ frame: APP_ERROR_TAG, payload }))
        }
    } catch (error) {
        /* eslint-disable-next-line no-console */
        console.log('error', error)
    }
}
